import {useState} from 'react';
import PassengerCard from './passengerDetailsCard';

export default function SectorCard({ sector }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="sector-card-sales">
      <div className='flexRow justifyContentSpaceBetween alignItemsCenter' onClick={() => setOpen(!open)}>
      <div className="sector-header-sales flexCol justifyContentFlexStart" >
        <strong>
          ✈ {sector.name} (Flight: {sector.flight})
        </strong>
        <p>
          STA: {sector.sta} / ATA: {sector.ata}
        </p>
      </div>
            <div className='sector-header-sales flexCol justifyContentFlexEnd'>
          <div className='flexRow'> Sector Sales:</div>
          <div className='flexRow justifyContentFlexEnd'> {sector.sales}</div>


        </div>
      </div>
      {open && (
        <div className="passenger-list">
<div className='flexRow justifyContentSpaceBetween card-sales-margin width100'>
<div className='flexRow justifyContentFlexStart'>Passenger / Seat / PNR / SSR</div>
<div>Crew / POS</div>
<div>Payment</div>
<div>Total</div>
</div>
          {sector.passengers.map((p) => (
            <PassengerCard passenger={p} key={p.pnr} />
          ))}
        </div>
      )}
    </div>
  );
}